HuesMdl.controller( 'SaveFanCtrl', ['$scope', 'effect_fan', 'color_fan', 'FanFilesSrv', 'HuesUpdaterSrv',
	function ( $scope, effect_fan, color_fan, FanFilesSrv, HuesUpdaterSrv ) {

	this.files = false;
	this.hasHues = false;

	var self = this,
		fan_id = ( effect_fan && color_fan ) ? color_fan.id : ( effect_fan &&  color_fan === false ) ? effect_fan.id : ( color_fan ) ? color_fan.id : false;

	if ( ! fan_id )
		return;

	$scope.$watch(function () { return HuesUpdaterSrv.hasHues;}, function( hasHues ){
		self.hasHues = hasHues;
	});
	FanFilesSrv.getFanFiles( fan_id ).then(
		function( files ) {

			if( files )
				self.files = files;

		}
	)




}]);
